import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      projects: {
        mini: {
          grid: {
            heading: "Grid",
            overview: `Employed the power of CSS grid to organize and showcase stunning imagery in a visually striking manner. <br><br>Demonstrated proficiency in grid-based layout design, incorporating innovative approaches learned from "The HTML and CSS Bootcamp by Colt Steele (UDEMY)."`,
            viewProj: "/reggenius/project?grid=true",
            codeLink:
              "https://github.com/Reggenius/Internship/tree/main/Grid%20Project",
            demonstration: null,
          },
          artist: {
            heading: "Artist Portfolio",
            overview: `Utilized CSS grid property to curate visually captivating ceramic galleries, showcasing a diverse collection of pottery and sculptures.<br><br>Implemented advanced grid techniques learned from "The HTML and CSS Bootcamp by Colt Steele (UDEMY)" to create dynamic and responsive layouts.`,
            viewProj: "/reggenius/project?artist=true",
            codeLink:
              "https://github.com/Reggenius/Internship/tree/main/Artist%20Portfolio",
            demonstration: null,
          },
          blog: {
            heading: "Blog Post",
            overview: `Explored the nuances of typography and text formatting through an in-depth blog post, delving into techniques for enhancing readability and visual appeal. <br><br>Leveraged insights from "The HTML and CSS Bootcamp by Colt Steele (UDEMY)" to craft engaging and aesthetically pleasing text compositions.`,
            viewProj: "/reggenius/project?blog=true",
            codeLink:
              "https://github.com/Reggenius/Internship/tree/main/Blog%20Post",
            demonstration: null,
          },
          estimator: {
            heading: "Cost Estimator",
            overview: `Designed a sleek and user-friendly session cost template utilizing various CSS design properties and components. <br><br>Applied knowledge gained from "The HTML and CSS Bootcamp by Colt Steele (UDEMY)" to implement custom styling and layout techniques for an intuitive user experience.`,
            viewProj: "/reggenius/project?estimator=true",
            codeLink:
              "https://github.com/Reggenius/Internship/tree/main/Cost%20Estimator",
            demonstration: null,
          },
          hazel: {
            heading: "Hazel CV",
            overview: `Developed a comprehensive web portfolio for a blogger, blending HTML and CSS to present a professional and engaging CV. <br><br>Leveraged techniques from "The HTML and CSS Bootcamp by Colt Steele (UDEMY)" to create a visually appealing and user-friendly interface, tailored to showcase the blogger's expertise and personality.`,
            viewProj: "/reggenius/project?hazel=true",
            codeLink:
              "https://github.com/Reggenius/Internship/tree/main/Hazel%20CV",
            demonstration: null,
          },
          beezieSecondTask: {
            heading: "Web Design",
            overview: `Developed a responsive static webpage based on a given Figma design, focusing on clean layout and intuitive user experience. <br><br>Implemented using Vue.js, HTML, CSS, and JavaScript to ensure seamless interactivity and performance across devices.`,
            viewProj: "https://beezie-130point.web.app/second-task",
            codeLink: null,
            demonstration: null,
          },
        },
        mega: {
          portfolio: {
            heading: "Personal Website",
            overview: `Developed a comprehensive portfolio web application for an accountant, designed to highlight their professional expertise and services effectively.<br><br>Utilized Vue.js, a component based javascript framework, to build a highly interactive and dynamic user interface. This project demonstrates my ability to leverage modern web technologies to create applications that are not only functional but also visually appealing and user-friendly.`,
            viewProj: "https://lady-p-accounting.web.app/",
            codeLink: null,
            demonstration: null,
          },
          swipe: {
            heading: "Swipe",
            overview: `Crafted the index page for Swipe company from scratch using HTML, JavaScript, and extensive CSS styling. <br><br>Demonstrated proficiency in frontend development, leveraging techniques and best practices learned from "The HTML and CSS Bootcamp by Colt Steele (UDEMY)" to create a visually stunning and responsive web interface.`,
            viewProj: "/reggenius/project?swipe=true",
            codeLink: "https://github.com/Reggenius/Internship/tree/main/Swipe",
            demonstration: null,
          },
          coach: {
            heading: "Find a Coach",
            overview: `Engineered a robust frontend using Vue.js and Firebase Realtime database integration, facilitating seamless user interaction for both Coaches and Students <br><br>Applied Vue.js expertise using the methodologies learned from "Vue - The Complete Guide by Maximillian Schwarzmuller", enhancing user engagement and satisfaction.`,
            viewProj: "https://vue-http-demo-c812e.web.app/coaches",
            codeLink:
              "https://github.com/Reggenius/Internship/tree/main/Find%20a%20Coach/vue",
            demonstration: null,
          },
          vidly: {
            heading: "Vidly",
            overview: `Engineered a backend Movie renting API using Node.js, express, javascript and typescript; providing a reliable and efficient platform for managing movie rentals. <br><br>Leveraged advanced Node.js concepts and industry best practices from "Node.js course by Mosh Hamedani" to ensure optimal performance and scalability of the API.`,
            viewProj: null,
            codeLink: "https://github.com/Reggenius/Internship/tree/main/vidly",
            demonstration: null,
          },
          salary: {
            heading: "Salary Payment System",
            overview: `Developed a comprehensive web application for managing employee salaries, integrating Paystack APIs for secure and efficient payment processing. <br><br>Leveraged a tech stack comprising Node.js, Typescript, Vue.js, and XAMPP to deliver a robust and feature-rich solution, optimizing efficiency and accuracy in salary management processes.`,
            viewProj: "https://reggenius-uni-pay.onrender.com/",
            codeLink: null,
            demonstration: "/reggenius/project?salary=true",
          },
          beezieFirstTask: {
            heading: "Reverse Engineering",
            overview: `Reverse-engineered an existing web application by analyzing its API structure, data flow, and user interface interactions. <br><br>Rebuilt the application from scratch using Vue.js, implementing UI refinements, API calls and functional enhancements to improve usability and overall design and performance consistency.`,
            viewProj: "https://beezie-130point.web.app/first-task",
            codeLink: null,
            demonstration: null,
          },
        },
      },
      me: {
        para: "I'm Reginald Chikelu, a passionate full-stack web developer dedicated to crafting immersive digital experiences.",
        projects: ["Mini", "Mega"],
      },
    };
  },
  getters,
};
